import { get } from 'lodash'

const add_delta_sync_to_order = {
  5: (state) => {
    const orderDeltasSyncSuccessAt = get(state, 'order.orderDeltasSyncSuccessAt', null)

    return {
      ...state,
      order: {
        ...state.order,
        orderDeltasSyncSuccessAt: orderDeltasSyncSuccessAt,
      }
    }
  }
}

export default add_delta_sync_to_order
